import { useMemo } from 'preact/hooks'
import { formatPreorderDateLabel, formatPreorderStatusText } from 'helpers/stock-status'
import Icon from 'snippets/icon/icon'

function ProductStatus({ maxQuantity, isLoading, initProduct, isPreorder = false, isAvailable = false, earliestPODate = '', isPreorderBundle = false, lowStockMessageOverride = null, isPlpQuickAdd = false }) {
  const lowStockThreshold = window.productState.lowStockThreshold
  const lowStockMessage = window.productState.lowStockMessage
  let lowStockOverride
  if (isPlpQuickAdd === true) {
    lowStockOverride = lowStockMessageOverride
  } else {
    lowStockOverride = window.productState.lowStockMessageOverride
  }
  const outOfStockMessage = window.productState.outOfStockMessage

  const earliestPODateLabel = formatPreorderDateLabel(earliestPODate) || ''
  const hasValidPODate = earliestPODateLabel !== ''

  const getContent = (quantity) => {
    if (isPreorder) {
      return (
        <div className="product-atc-preorder mt-6 flex flex-row items-center gap-3">
          <Icon viewBox="0 0 24 24" name="icon-clock" className="h-6 w-6 min-w-6 text-grey-500" />
          <p className="text-sm text-grey-1000">
            {translate.product.preOrder}{' '}
            {translate.product.preOrderStatus && <span className="text-sm text-grey-500">- {translate.product.preOrderStatus}</span>}{' '}
            {hasValidPODate && (isPreorderBundle
              ? <span> — {formatPreorderStatusText(earliestPODateLabel)}</span>
              : <span> — Leaves warehouse by approximately {earliestPODateLabel}</span>)}
          </p>
        </div>
      )
    } else {
      if (isAvailable && quantity > 0 && quantity <= lowStockThreshold) {
        return (
          <div className="mt-6 flex flex-row items-center gap-3">
            <Icon viewBox="0 0 10 10" name="icon-check" className="m-[3px] h-6 w-6 min-w-6 rounded-full border-2 border-warning-content p-1 text-warning-content" />
            <p className="text-grey-1000">
              Only {quantity} left {maxQuantity > 0 && <span className="text-grey-500">- {lowStockOverride !== null ? lowStockOverride : lowStockMessage}</span>}
            </p>
          </div>
        )
      } else if (isAvailable && quantity > lowStockThreshold) {
        return (
          <p className="mt-6 text-grey-1000">
            {translate.product.inStock}
            <span className="text-grey-500"> - {lowStockOverride !== null ? lowStockOverride : lowStockMessage}</span>
          </p>
        )
      } else {
        return (
          <div className="mt-6 flex flex-row items-center gap-3">
            <Icon viewBox="0 0 24 24" name="icon-close" className="h-6 w-6 min-w-6 text-grey-500" />
            <p className="text-grey-1000">
              <span>{translate.product.outStock}</span>
              {outOfStockMessage && <span className="text-grey-500"> - {outOfStockMessage}</span>}
            </p>
          </div>
        )
      }
    }
  }

  const content = useMemo(
    () => getContent(maxQuantity),
    [maxQuantity, isPreorder, isAvailable, earliestPODate, isPreorderBundle]
  )

  return !isLoading ? (
    <div className="text-sm">{content}</div>
  ) : (
    <div className="relative animate-pulse">
      <div class="mt-4 h-6 w-full bg-grey-200"></div>
    </div>
  )
}

export default ProductStatus
